import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Newspaper, Calendar, GraduationCap, Globe, Smile, Heart, Users, Briefcase, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  if (loading) return null;

  const links = [
    { icon: Home, label: 'Home', path: '/' },
    { icon: Users, label: 'Communities', path: '/messages?section=english' },
    { icon: Briefcase, label: 'Tools', path: '/study-hub' },
    { icon: Calendar, label: 'Events', path: '/events' },
    { icon: User, label: 'Profile', path: '/profile' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  if (location.pathname === '/crushes') {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-background/90 dark:bg-slate-950/90 backdrop-blur-lg border-t dark:border-slate-800 flex justify-start sm:justify-around items-center h-16 safe-area-bottom lg:hidden overflow-x-auto px-2 no-scrollbar shadow-[0_-4px_15px_rgba(0,0,0,0.05)] dark:shadow-[0_-4px_15px_rgba(0,0,0,0.2)]" data-testid="mobile-bottom-nav">
      {links.map(({ icon: Icon, label, path }) => (
        <button
          key={label}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(path);
          }}
          className={`flex flex-col items-center justify-center min-w-[56px] gap-0.5 px-3 py-2 transition-colors ${
            isActive(path) ? 'text-gold' : 'text-muted-foreground dark:text-slate-400 hover:text-foreground dark:hover:text-slate-200'
          }`}
          data-testid={`mobile-nav-${label.toLowerCase()}`}
        >
          <Icon className="h-5 w-5 shrink-0" />
          <span className="text-[8px] font-mono whitespace-nowrap">{label}</span>
        </button>
      ))}
    </div>
  );
}
